

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"width":"120","height":"120","viewBox":"0 0 120 120","xmlns":"http://www.w3.org/2000/svg"}, rest), [h('path', {"d":"M52.02 64.723L71.563 45.18l3.257 3.257L55.277 67.98l-3.257-3.257zM40.075 83.25a2.352 2.352 0 11-3.326-3.326l2.825-2.825 3.326 3.326-2.825 2.825zm47.596-51.749L72.05 31.5a.83.83 0 00-.587.243L44.836 58.37l-3.36-3.36-3.358 3.358 6.716 6.72-11.248 11.249a7.129 7.129 0 00-.003 10.075 7.126 7.126 0 0010.078 0L54.91 75.164l6.719 6.719 3.359-3.358-3.361-3.36 26.625-26.63a.83.83 0 00.243-.587l.005-15.616a.83.83 0 00-.83-.83z","fill":"#FFF","fill-rule":"evenodd"}, [])]);
};

        